// import Promotion from "../../assets/images/promotions/promotions.jpg";
// import Criteria from "../../assets/images/promotions/criteria.jpg";
import FirstDeposit from "../../assets/images/promotions/first-deposit.jpg";
import SecondDeposit from "../../assets/images/promotions/second-deposit.jpg";
import ThirdDeposit from "../../assets/images/promotions/third-deposit.jpg";
import Referral from "../../assets/images/promotions/referral.jpg";
import SignUpBonus from "../../assets/images/promotions/SignupBonus.gif";
import UPIDepositBonus from "../../assets/images/promotions/everydepositbonus.jpg";
import Play from "../../assets/images/play-button.png";

import SignupBonusBanner from "../../assets/images/banner/1.jpg";
import EveryUpibonnus from "../../assets/images/banner/2.jpg";
import FirstDepositBonus from "../../assets/images/banner/3.jpg";
import NDDepositBonus from "../../assets/images/banner/2NDDepositBonus.jpg";
import rdDepositBonus from "../../assets/images/banner/3rdDepositBonus.jpg";
import ReferralBonus from "../../assets/images/banner/ReferralBonus.jpg";

export const postData = [
  {
    heading: "Sign Up Bonus",
    imgUrl: SignUpBonus,
    promotionName: "Sign Up Bonus",
    content: (
      <>
        <h4 className="Heading">Sign Up Bonus</h4>

        <div className="PromotionBonusBanner mb-4">
          <img src={SignupBonusBanner} alt="banner" />
        </div>
        <p>
          Upon joining Dial4bet, you'll instantly receive a 50 Rs Sign Up Bonus
          that you can use to explore a wide range of thrilling games and slot
          games. You can start Gaming on your favourite games with the sign-up
          bonus amount, however, in case of any win, you will get ONLY the
          winning amount and not the Gaming amount. Feel the adrenaline rush as
          you dive into our dynamic selection of games, each designed to provide
          you with a unique and captivating gaming experience.
        </p>
        <p>
          <span>
            {" "}
            <span>*Please Note:</span>
          </span>{" "}
          If any user registers from multiple IDs or IP addresses, the website
          holds all the rights to ban their account. Their bonus amount will be
          cancelled to nil. *
        </p>
      </>
    ),
  },

  {
    heading: "Every UPI Deposit",
    imgUrl: UPIDepositBonus,
    promotionName: "Every UPI Deposit",
    content: (
      <>
        <h4 className="Heading">Every UPI Deposit</h4>
        <div className="PromotionBonusBanner mb-4">
          <img src={EveryUpibonnus} alt="banner" />
        </div>
        <p>
          Upon joining Dial4bet, you will get 3% Direct cash bonus on your every
          UPI deposit.
        </p>
      </>
    ),
  },

  {
    heading: "First Deposit Bonus",
    imgUrl: FirstDeposit,
    promotionName: "First Deposit Bonus",
    content: (
      <>
        <h4 className="Heading">First Deposit Bonus</h4>
        <div className="PromotionBonusBanner mb-4">
          <img src={FirstDepositBonus} alt="banner" />
        </div>
        <p>
          Get up to a 300% First Deposit Bonus as a member of the Dial4bet club!
          Make your first deposit in your Dial4bet account and get eligible for
          an exciting bonus.
        </p>
        <p>
          On a deposit of 300 Rs and above, you will get a 300% deposit bonus.
        </p>
        <p>
          To avail of the bonus of the first deposit, the user must get a 30X
          turnover within 30 days of time duration. After 30 days the bonus will
          expire, and the user can cancel the bonus from their end.
        </p>
        <p>
          <span> *Please Note:</span> If any user registers from multiple IDs or
          IP addresses, the website holds all the rights to ban their account.
          Their bonus amount will be cancelled to nil. *
        </p>
        <p>
          {" "}
          <span> *Please Note:</span> The maximum bonus amount will be up to
          50,000 Rs. *
        </p>
        <p>
          <span> Please Note:</span> In this rollover/turnover, it is not
          compulsory that you must complete full 30x rollover to get your bonus
          amount, if you do 10x in the given 30 days’ time then you will get
          bonus according to your rollover.
        </p>
        <p>
          <span>*Please Note:</span> Only one rollover bonus will be active at a
          time, until it is completed the second one will not be activated, and
          the bonus will be received in the same sequence in which it is
          received. *
        </p>
        <h4>Criteria For Turnover In Games (Ezugi)</h4>
        <ul>
          <li>
            <span style={{ color: "#ff0000" }}> Dragon Tiger- </span> Only
            played on Dragon will be counted in the turnover
          </li>
          <li>
            <span style={{ color: "#ff0000" }}> Andar Bahar - </span>
            Only played on Andar will be counted in the turnover
          </li>
          <li>
            <span style={{ color: "#ff0000" }}> Lucky7-</span> Only played on 7
            down will be counted in the turnover
          </li>
          <li>
            <span style={{ color: "#ff0000" }}> Baccarat- </span>Only played on
            Banker will be counted in the turnover
          </li>
          <li>
            <span style={{ color: "#ff0000" }}> Cricket War-</span> Only played
            on bowler will be counted in the turnover
          </li>
          <li>
            {" "}
            <span style={{ color: "#ff0000" }}> Sic Bo-</span> Played on
            odd,even,big and small won't be counted and rest of all played will
            be counted in the turnover.
          </li>
          <li>
            {" "}
            <span style={{ color: "#ff0000" }}> Speed Roulette-</span> Played on
            Black, Red, Odd, Even, 1-18 and 19-36 won't be counted and rest of
            all will be counted in the turnover.
          </li>
        </ul>

        <h4 className="mt-4">Criteria For Turnover In Sportsbook </h4>
        <ul>
          <li>
            The user can play all the sports for the turnover but the odds
            should be above 1.67 only after that user’s Gaming amount is
            calculated in turnover.
          </li>
        </ul>
      </>
    ),
  },

  {
    heading: "Second Deposit Bonus",
    imgUrl: SecondDeposit,
    promotionName: "Second Deposit Bonus",
    content: (
      <>
        <h4 className="Heading">Second Deposit Bonus</h4>
        <div className="PromotionBonusBanner mb-4">
          <img src={NDDepositBonus} alt="banner" />
        </div>
        <p>
          Get up to a 50% Second Deposit Bonus as a member of the Dial4bet club!
          Not just the first time but get lucky the second time you make a
          deposit in your Dial4bet account and get an exciting bonus.
        </p>
        <p>
          <span>Ex.</span> If you invest 1000 Rs, you will earn a 500 Rs
          incentive. The bonus will be divided into ten equal parts and will be
          received when you complete the turnover.
        </p>
        <p>
          To activate the bonus of the second deposit, the user must get 15X
          turnover within 15 days of time duration. After 15 days the bonus will
          expire, and the user can cancel the bonus from their end.
        </p>
        <p>
          <span>*Please Note:</span> If any user registers from multiple IDs or
          IP addresses, the website holds all the rights to ban their account.
          Their bonus amount will be cancelled to nil. *
        </p>
        <p>
          {" "}
          <span>*Please Note:</span> The maximum bonus amount will be up to
          50,000 Rs. *
        </p>
        <p>
          <span>*Please Note:</span> In this rollover/turnover, it is not
          compulsory that you must complete full 15x rollover to get your bonus
          amount, if you do 10x in the given 15 days’ time then you will get
          bonus according to your rollover
        </p>
        <p>
          <span>*Please Note:</span> Only one rollover bonus will be active at a
          time, until it is completed the second one will not be activated, and
          the bonus will be received in the same sequence in which it is
          received. *
        </p>
        <h4>Criteria For Turnover In Games (Ezugi)</h4>
        <ul>
          <li>
            <span style={{ color: "#ff0000" }}> Dragon Tiger-</span> Only played
            on Dragon will be counted in the turnover
          </li>
          <li>
            <span style={{ color: "#ff0000" }}> Andar Bahar - </span>
            Only played on Andar will be counted in the turnover
          </li>
          <li>
            <span style={{ color: "#ff0000" }}> Lucky7- </span>Only played on 7
            down will be counted in the turnover
          </li>
          <li>
            <span style={{ color: "#ff0000" }}> Baccarat-</span> Only played on
            Banker will be counted in the turnover
          </li>
          <li>
            <span style={{ color: "#ff0000" }}> Cricket War-</span> Only played
            on bowler will be counted in the turnover
          </li>
          <li>
            {" "}
            <span style={{ color: "#ff0000" }}> Sic Bo-</span>Played on
            odd,even,big and small won't be counted and rest of all played will
            be counted in the turnover.
          </li>
          <li>
            <span style={{ color: "#ff0000" }}>Speed Roulette- </span>
            Played on Black, Red, Odd, Even, 1-18 and 19-36 won't be counted and
            rest of all played will be counted in the turnover.
          </li>
        </ul>

        <h4 className="mt-2">Criteria For Turnover In Sportsbook </h4>
        <ul>
          <li>
            The user can play all the sports for the turnover but the odds
            should be above 1.67 only after that user’s Gaming amount is
            calculated in turnover.
          </li>
        </ul>
      </>
    ),
  },

  {
    heading: "Third Deposit Bonus",
    imgUrl: ThirdDeposit,
    promotionName: "Third Deposit Bonus",
    content: (
      <>
        <h4 className="Heading">Third Deposit Bonus</h4>
        <div className="PromotionBonusBanner mb-4">
          <img src={rdDepositBonus} alt="banner" />
        </div>
        <p>
          Get up to 25% Third Deposit Bonus as a member of the Dial4bet club!
          They say the third time’s the charm. Now, you can get an exciting
          bonus for making your third deposit in your Dial4bet account.
        </p>
        <p>
          <span>Ex.</span> If you invest 1000 Rs, you will earn a 250 Rs
          incentive. The bonus will be divided into ten equal parts and will be
          received when you complete the turnover.
        </p>
        <p>
          To avail of a bonus of the third deposit, the user must get 10X
          turnover within 10 days of time duration. After 10 days the bonus will
          expire, and the user can cancel the bonus from their end.
        </p>
        <p>
          <span>*Please Note:</span> If any user registers from multiple IDs or
          IP addresses, the website holds all the rights to ban their account.
          Their bonus amount will be cancelled to nil. *
        </p>
        <p>
          {" "}
          <span>*Please Note:</span> The maximum bonus amount will be up to
          50,000 Rs. *
        </p>
        <p>
          <span>*Please Note:</span> In this rollover/turnover, it is not
          compulsory that you must complete full 10x rollover to get your bonus
          amount, if you do 5x in the given 10 days’ time then you will get
          bonus according to your rollover
        </p>
        <p>
          <span>*Please Note:</span> Only one rollover bonus will be active at a
          time, until it is completed the second one will not be activated, and
          the bonus will be received in the same sequence in which it is
          received. *
        </p>
        <h4>Criteria For Turnover In Games (Ezugi)</h4>
        <ul>
          <li>
            <span style={{ color: "#ff0000" }}>Dragon Tiger-</span> Only played
            on Dragon will be counted in the turnover
          </li>
          <li>
            <span style={{ color: "#ff0000" }}>Andar Bahar -</span> Only played
            on Andar will be counted in the turnover
          </li>
          <li>
            <span style={{ color: "#ff0000" }}>Lucky7-</span> Only played on 7
            down will be counted in the turnover
          </li>
          <li>
            <span style={{ color: "#ff0000" }}>Baccarat-</span> Only played on
            Banker will be counted in the turnover
          </li>
          <li>
            <span style={{ color: "#ff0000" }}> Cricket War-</span> Only played
            on bowler will be counted in the turnover
          </li>
          <li>
            {" "}
            <span style={{ color: "#ff0000" }}> Sic Bo- </span>Played on
            odd,even,big and small won't be counted and rest of all will be
            counted in the turnover.
          </li>
          <li>
            <span style={{ color: "#ff0000" }}> Speed Roulette-</span> Played on
            Black, Red, Odd, Even, 1-18 and 19-36 won't be counted and rest of
            all will be counted in the turnover.
          </li>
        </ul>

        <h4 className="mt-2">Criteria For Turnover In Sportsbook </h4>
        <ul>
          <li>
            The user can play all the sports for the turnover but the odds
            should be above 1.67 only after that user’s gaming amount is
            calculated in turnover.
          </li>
        </ul>
      </>
    ),
  },

  {
    heading: "Referral Bonus",
    imgUrl: Referral,
    promotionName: "Referral Bonus",
    content: (
      <>
        <h4 className="Heading">Referral Bonus</h4>
        <div className="PromotionBonusBanner mb-4">
          <img src={ReferralBonus} alt="banner" />
        </div>
        <p>
          Share your referral code with your friends and family and get up to a
          15% bonus on every deposit made by the referred player. The bonus will
          be received only after the player makes 35X turnover in the time of 20
          days.
        </p>
        <p>
          <span>Ex.</span> If your Friend invest 1000 Rs, you will earn a 150 Rs
          bonus. The bonus will be divided into ten equal parts and will be
          received when you complete the turnover.
        </p>
        <p>
          <span>*Please Note:</span> If any user registers from multiple IDs or
          IP addresses, the website holds all the rights to ban their account.
          Their bonus amount will be cancelled to nil. *
        </p>
        <p>
          {" "}
          <span>*Please Note:</span> The maximum bonus amount will be up to
          50,000 Rs. *
        </p>
        <p>
          <span>*Please Note:</span> In this rollover/turnover, it is not
          compulsory that you have to complete full 35x rollover to get your
          bonus amount, if you do 10x in the given 20 days’ time then you will
          get bonus according to your rollover
        </p>
        <p>
          <span>*Please Note:</span> Only one rollover bonus will be active at a
          time, until it is completed the second one will not be activated, and
          the bonus will be received in the same sequence in which it is
          received. *
        </p>
        <h4>Criteria For Turnover In Games (Ezugi)</h4>
        <ul>
          <li>
            <span style={{ color: "#ff0000" }}> Dragon Tiger- </span>
            .Only played on Dragon will be counted in the turnover
          </li>
          <li>
            <span style={{ color: "#ff0000" }}> Andar Bahar -</span> Only played
            on Andar will be counted in the turnover
          </li>
          <li>
            <span style={{ color: "#ff0000" }}>Lucky7-</span> Only played on 7
            down will be counted in the turnover
          </li>
          <li>
            <span style={{ color: "#ff0000" }}> Baccarat- </span>Only played on
            Banker will be counted in the turnover
          </li>
          <li>
            <span style={{ color: "#ff0000" }}> Cricket War-</span> Only played
            on bowler will be counted in the turnover
          </li>
          <li>
            {" "}
            <span style={{ color: "#ff0000" }}> Sic Bo- </span>Played on
            odd,even,big and small won't be counted and rest of all will be
            counted in the turnover.
          </li>
          <li>
            <span style={{ color: "#ff0000" }}> Speed Roulette-</span> Played on
            Black, Red, Odd, Even, 1-18 and 19-36 won't be counted and rest of
            all played will be counted in the turnover.
          </li>
        </ul>

        <h4 className="mt-2">Criteria For Turnover In Sportsbook </h4>
        <ul>
          <li>
            The user can play all the sports for the turnover but the odds
            should be above 1.67 only after that user’s Gaming amount is
            calculated in turnover.
          </li>
        </ul>
      </>
    ),
  },
];
